function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import Log from '@deephaven/log';
import { PromiseUtils } from '@deephaven/utils';
import ContextActionUtils from "./ContextActionUtils.js";
import ContextMenuItem from "./ContextMenuItem.js";
import LoadingSpinner from "../LoadingSpinner.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var log = Log.module('ContextMenu');
/** Do not use this class directly. Use ContextMenuRoot and ContextActions instead. */
class ContextMenu extends PureComponent {
  static handleContextMenu(e) {
    if (e.metaKey) {
      return;
    }
    e.stopPropagation();
    e.preventDefault();
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "container", void 0);
    _defineProperty(this, "oldFocus", void 0);
    _defineProperty(this, "activeSubMenuRef", void 0);
    _defineProperty(this, "subMenuTimer", void 0);
    _defineProperty(this, "rAF", void 0);
    _defineProperty(this, "initialPosition", void 0);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleCloseSubMenu = this.handleCloseSubMenu.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleMenuItemClick = this.handleMenuItemClick.bind(this);
    this.handleMenuItemContextMenu = this.handleMenuItemContextMenu.bind(this);
    this.handleMenuItemMouseMove = this.handleMenuItemMouseMove.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleWindowResize = this.handleWindowResize.bind(this);
    this.container = /*#__PURE__*/React.createRef();
    this.oldFocus = document.activeElement;
    this.activeSubMenuRef = /*#__PURE__*/React.createRef();
    this.subMenuTimer = 0;
    this.rAF = 0;
    this.initialPosition = {
      top: props.top,
      left: props.left
    };
    this.state = {
      menuItems: [],
      pendingItems: [],
      activeSubMenu: null,
      hasOverflow: false,
      subMenuTop: null,
      subMenuLeft: null,
      subMenuParentWidth: 0,
      subMenuParentHeight: 0,
      keyboardIndex: -1,
      mouseIndex: -1
    };
  }
  componentDidMount() {
    this.initMenu();
    this.verifyPosition();
    window.addEventListener('resize', this.handleWindowResize);

    // rAF is needed to wait for a submenus popper to be created before
    // attempting to set focus, however on a quick mount/unmount when
    // mousing past an item, the submenu could be unmounted before the
    // async rAF finishes, so it is cancelled in willUnmount()
    this.rAF = window.requestAnimationFrame(() => {
      var _this$container$curre;
      (_this$container$curre = this.container.current) === null || _this$container$curre === void 0 || _this$container$curre.focus();
      var onMenuOpened = this.props.onMenuOpened;
      onMenuOpened(this);
    });
  }
  componentDidUpdate(prevProps, prevState) {
    var actions = this.props.actions;
    var activeSubMenu = this.state.activeSubMenu;
    if (activeSubMenu !== prevState.activeSubMenu) {
      if (activeSubMenu == null) {
        var _this$container$curre2;
        // close sub menu, refocus parent menu
        (_this$container$curre2 = this.container.current) === null || _this$container$curre2 === void 0 || _this$container$curre2.focus();
      } else {
        // open sub menu, set its initial position
        this.setActiveSubMenuPosition();
      }
    }
    if (prevProps.actions !== actions) {
      this.initMenu();
      if (this.container.current == null || !this.container.current.contains(document.activeElement)) {
        var _this$container$curre3;
        (_this$container$curre3 = this.container.current) === null || _this$container$curre3 === void 0 || _this$container$curre3.focus();
      }
    }
    this.verifyPosition();
  }
  componentWillUnmount() {
    this.cancelPromises();
    window.removeEventListener('resize', this.handleWindowResize);
    cancelAnimationFrame(this.rAF);
  }
  getKeyboardIndex() {
    var options = this.props.options;
    if (options.separateKeyboardMouse !== undefined && options.separateKeyboardMouse) {
      var keyboardIndex = this.state.keyboardIndex;
      return keyboardIndex;
    }
    return this.getMouseIndex();
  }
  setKeyboardIndex(index) {
    var options = this.props.options;
    if (options.separateKeyboardMouse !== undefined && options.separateKeyboardMouse) {
      this.setState({
        keyboardIndex: index
      });
    } else {
      this.setMouseIndex(index);
    }
  }
  getMouseIndex() {
    var mouseIndex = this.state.mouseIndex;
    return mouseIndex;
  }
  setMouseIndex(index) {
    this.setState({
      mouseIndex: index
    });
  }
  initMenu() {
    // cancel any pending close and promises
    this.cancelPromises();
    cancelAnimationFrame(this.rAF);
    var options = this.props.options;
    var keyboardIndex = options.initialKeyboardIndex;
    if (keyboardIndex === undefined) {
      keyboardIndex = -1;
    }
    var actions = this.props.actions;
    var menuItems = ContextActionUtils.getMenuItems(actions);
    var nonPromiseItems = [];
    for (var i = menuItems.length - 1; i >= 0; i -= 1) {
      var menuItem = menuItems[i];
      if (menuItem instanceof Promise) {
        this.initMenuPromise(menuItem);
      } else {
        nonPromiseItems.push(menuItem);
      }
    }
    this.setState({
      mouseIndex: -1,
      keyboardIndex,
      activeSubMenu: null,
      menuItems: ContextActionUtils.sortActions(nonPromiseItems)
    });
  }
  initMenuPromise(promise) {
    // make all promises cancellable
    var cancellablePromise = PromiseUtils.makeCancelable(promise);
    this.setState(state => ({
      pendingItems: state.pendingItems.concat(cancellablePromise)
    }));
    cancellablePromise.then(resolvedMenuItems => {
      this.setState(state => {
        var index = state.pendingItems.indexOf(cancellablePromise);
        if (index >= 0) {
          var pendingItems = state.pendingItems.slice();
          pendingItems.splice(index, 1);
          return {
            menuItems: ContextActionUtils.sortActions(state.menuItems.concat(resolvedMenuItems)),
            pendingItems
          };
        }
        // This item is stale, don't update the menu
        return null;
      });
    }, error => {
      if (PromiseUtils.isCanceled(error)) {
        return; // Canceled promise is ignored
      }

      // remove failed item from pending list
      this.setState(state => {
        var index = state.pendingItems.indexOf(cancellablePromise);
        if (index >= 0) {
          var pendingItems = state.pendingItems.slice();
          pendingItems.splice(index, 1);
          return {
            pendingItems
          };
        }
        return null;
      });

      // Log the error
      log.error(error);
    });
  }
  cancelPromises() {
    var pendingItems = this.state.pendingItems;
    pendingItems.map(item => item.cancel());
  }

  /**
   * Sets the unverfied start position of a submenu. Submenu then self-verfies
   * its own position and potentially reports back a new position.
   */
  setActiveSubMenuPosition() {
    if (this.activeSubMenuRef.current === null) return;
    var parentRect = this.activeSubMenuRef.current.getBoundingClientRect();

    // intentionally rect.right, we want the sub menu to start at the right edge of the current menu
    this.setState({
      subMenuTop: parentRect.top,
      subMenuLeft: parentRect.right,
      subMenuParentHeight: parentRect.height,
      subMenuParentWidth: parentRect.width
    });
  }

  /**
   * Verifies the position of this menu in relation to the parent to make sure it's on screen.
   * Will update the top left state (updatePosition) if necessary (causing a re-render)
   * By default it tries to top-align with parent, at the right side of the parent.
   * Because we aren't a native context menu and can't escape window bounds, we also do
   * somethings to better fit on screen, such as the "nudge" offset position, and further
   * allow overflow scrolling for large menus in a small window.
   */
  verifyPosition() {
    var _this$container$curre4, _this$container$curre5, _this$container$curre6, _this$container$curre7;
    var _this$props = this.props,
      options = _this$props.options,
      updatePosition = _this$props.updatePosition,
      subMenuParentWidth = _this$props.subMenuParentWidth,
      subMenuParentHeight = _this$props.subMenuParentHeight,
      oldTop = _this$props.top,
      oldLeft = _this$props.left;
    if (!this.container.current || options.doNotVerifyPosition != null && options.doNotVerifyPosition) {
      return;
    }

    // initial position is used rather than current position,
    // as the number of menu items can change (actions can bubble)
    // and menu should always be positioned relative to spawn point
    var _this$initialPosition = this.initialPosition,
      top = _this$initialPosition.top,
      left = _this$initialPosition.left;
    var _ref = (_this$container$curre4 = (_this$container$curre5 = this.container.current) === null || _this$container$curre5 === void 0 ? void 0 : _this$container$curre5.getBoundingClientRect()) !== null && _this$container$curre4 !== void 0 ? _this$container$curre4 : {
        width: 0,
        height: 0
      },
      width = _ref.width,
      height = _ref.height;
    var hasOverflow = ((_this$container$curre6 = (_this$container$curre7 = this.container.current) === null || _this$container$curre7 === void 0 ? void 0 : _this$container$curre7.scrollHeight) !== null && _this$container$curre6 !== void 0 ? _this$container$curre6 : 0) > window.innerHeight;
    if (height === 0 || width === 0) {
      // We don't have a height or width yet, don't bother doing anything
      return;
    }

    // does it fit below?
    if (top + height > window.innerHeight) {
      // can it be flipped to above? include offset if submenu (defaults to 0 if not submenu)
      if (top - height - subMenuParentHeight > 0) {
        // flip like a native menu would
        top -= height - subMenuParentHeight;
      } else {
        // still doesnt fit? okay, position at bottom edge
        top = window.innerHeight - height;
      }
    }
    if (left + width > window.innerWidth) {
      // less picky about left right positioning, just keep it going off to right
      left = left - width - subMenuParentWidth;
    }
    if (oldLeft !== left || oldTop !== top) {
      // parent owns positioning as single source of truth, ask to update props
      this.setState({
        hasOverflow
      });
      updatePosition(top, left);
    }
  }

  // since window resize doesn't trigger blur, listen and close the menu
  handleWindowResize() {
    if (!this.container.current) {
      return;
    }
    this.closeMenu(true);
  }
  handleBlur(e) {
    if (!this.container.current) {
      log.warn('Container is null!');
      return;
    }
    if (!this.container.current.contains(e.relatedTarget)) {
      var element = e.relatedTarget;
      var isContextMenuChild = false;
      while (element && !isContextMenuChild) {
        isContextMenuChild = element.hasAttribute('data-dh-context-menu');
        element = element.parentElement;
      }
      if (!isContextMenuChild) {
        // close all submenus on blur
        this.closeMenu(true);
      }
    }
  }

  /** Returns whether the specified key should remove the menu. Depends on the side the parent is on. */
  isEscapeKey(key) {
    var left = this.props.left;
    return key === 'Escape' || left < 0 && key === 'ArrowRight' || key === 'ArrowLeft';
  }
  handleKeyDown(e) {
    var menuItems = this.state.menuItems;
    var oldFocus = this.getKeyboardIndex();
    var newFocus = oldFocus;
    var openSubMenu = false;
    if (e.key === 'Enter' || e.key === ' ') {
      if (oldFocus >= 0 && oldFocus < menuItems.length) {
        this.handleMenuItemClick(menuItems[oldFocus], e);
      }
      return;
    }
    if (e.key === 'ArrowRight') {
      if (oldFocus >= 0 && oldFocus <= menuItems.length) {
        openSubMenu = true;
      } else {
        newFocus = 0;
      }
    } else if (this.isEscapeKey(e.key)) {
      newFocus = null;
    } else if (e.key === 'ArrowUp' || e.shiftKey && e.key === 'Tab') {
      newFocus = ContextActionUtils.getNextMenuItem(newFocus, -1, menuItems);
    } else if (e.key === 'ArrowDown' || e.key === 'Tab') {
      newFocus = ContextActionUtils.getNextMenuItem(newFocus, 1, menuItems);
    }
    if (openSubMenu) {
      this.openSubMenu(oldFocus);
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (oldFocus !== newFocus) {
      if (newFocus !== null) {
        this.setKeyboardIndex(newFocus);
      } else {
        this.closeMenu();
        if (this.oldFocus instanceof HTMLElement) {
          this.oldFocus.focus();
        }
      }
      e.preventDefault();
      e.stopPropagation();
    }
  }
  openSubMenu(index) {
    var _this$state = this.state,
      menuItems = _this$state.menuItems,
      activeSubMenu = _this$state.activeSubMenu;
    var newSubMenu = menuItems[index].actions ? index : null;
    if (activeSubMenu === newSubMenu) return;
    this.setState({
      activeSubMenu: newSubMenu,
      subMenuTop: null,
      subMenuLeft: null
    });
  }
  closeMenu() {
    var closeAll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _this$props2 = this.props,
      closeMenu = _this$props2.closeMenu,
      onMenuClosed = _this$props2.onMenuClosed;
    cancelAnimationFrame(this.rAF);
    this.rAF = window.requestAnimationFrame(() => {
      closeMenu(closeAll);
      onMenuClosed(this);
    });
  }
  closeSubMenu() {
    this.setState({
      activeSubMenu: null
    });
  }
  handleCloseSubMenu(closeAllMenus) {
    if (closeAllMenus) {
      this.closeMenu(true);
    } else {
      this.closeSubMenu();
    }
  }
  handleMenuItemClick(menuItem, e) {
    e.preventDefault();
    e.stopPropagation();
    var menuItems = this.state.menuItems;
    if (menuItem != null && (menuItem.disabled === undefined || !menuItem.disabled)) {
      if (menuItem.actions != null) {
        this.openSubMenu(menuItems.indexOf(menuItem));
      } else if (menuItem.action != null) {
        menuItem.action(e.nativeEvent);
        this.closeMenu(true);
      }
    }
  }
  handleMenuItemContextMenu(menuItem, e) {
    if (e.metaKey) {
      return;
    }
    this.handleMenuItemClick(menuItem, e);
  }
  handleMenuItemMouseMove(menuItem) {
    var menuItems = this.state.menuItems;
    var focusIndex = menuItems.indexOf(menuItem);
    this.setMouseIndex(focusIndex);
    if (focusIndex >= 0 && focusIndex < menuItems.length && (menuItem.disabled === undefined || !menuItem.disabled)) {
      this.openSubMenu(focusIndex);
    }
  }
  handleMouseLeave() {
    this.setMouseIndex(-1);
  }
  render() {
    var menuItemElements = [];
    var _this$props3 = this.props,
      top = _this$props3.top,
      left = _this$props3.left;
    var _this$state2 = this.state,
      activeSubMenu = _this$state2.activeSubMenu,
      hasOverflow = _this$state2.hasOverflow,
      keyboardIndex = _this$state2.keyboardIndex,
      menuItems = _this$state2.menuItems,
      mouseIndex = _this$state2.mouseIndex,
      pendingItems = _this$state2.pendingItems,
      subMenuTop = _this$state2.subMenuTop,
      subMenuLeft = _this$state2.subMenuLeft,
      subMenuParentWidth = _this$state2.subMenuParentWidth,
      subMenuParentHeight = _this$state2.subMenuParentHeight;
    for (var i = 0; i < menuItems.length; i += 1) {
      var menuItem = menuItems[i];
      if (i > 0 && menuItem.group !== menuItems[i - 1].group) {
        menuItemElements.push(/*#__PURE__*/_jsx("hr", {}, "".concat(i, ".separator")));
      }
      var menuItemElement = /*#__PURE__*/_jsx(ContextMenuItem, {
        ref: activeSubMenu === i ? this.activeSubMenuRef : null,
        isKeyboardSelected: keyboardIndex === i,
        isMouseSelected: mouseIndex === i,
        menuItem: menuItem,
        closeMenu: this.handleCloseSubMenu,
        onMenuItemClick: this.handleMenuItemClick,
        onMenuItemMouseMove: this.handleMenuItemMouseMove,
        onMenuItemContextMenu: this.handleMenuItemContextMenu
      }, i);
      menuItemElements.push(menuItemElement);
    }
    var pendingElement = null;
    if (pendingItems.length > 0) {
      pendingElement = /*#__PURE__*/_jsx("div", {
        className: "loading",
        children: /*#__PURE__*/_jsx(LoadingSpinner, {
          className: "loading-spinner-vertical-align"
        })
      });
    }
    var _this$props4 = this.props,
      menuStyle = _this$props4.menuStyle,
      dataTestId = _this$props4['data-testid'];

    // don't show submenu until it has an position initialized
    var showSubmenu = activeSubMenu !== null && subMenuTop !== null && subMenuLeft !== null;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: classNames({
          'has-overflow': hasOverflow
        }, 'context-menu-container'),
        style: _objectSpread({
          top,
          left
        }, menuStyle),
        ref: this.container,
        "data-dh-context-menu": true,
        onBlur: this.handleBlur,
        onKeyDown: this.handleKeyDown,
        onMouseLeave: this.handleMouseLeave,
        onContextMenu: ContextMenu.handleContextMenu,
        role: "menuitem",
        tabIndex: 0,
        "data-testid": dataTestId,
        children: [menuItemElements, pendingElement]
      }), showSubmenu && activeSubMenu !== null && subMenuTop !== null && subMenuLeft !== null && /*#__PURE__*/_jsx(ContextMenu, {
        actions: menuItems[activeSubMenu].actions || [],
        closeMenu: this.handleCloseSubMenu,
        top: subMenuTop,
        left: subMenuLeft,
        updatePosition: (verifiedTop, verifiedLeft) => {
          this.setState({
            subMenuTop: verifiedTop,
            subMenuLeft: verifiedLeft
          });
        },
        subMenuParentWidth: subMenuParentWidth,
        subMenuParentHeight: subMenuParentHeight
      }, "sub-".concat(activeSubMenu))]
    });
  }
}
_defineProperty(ContextMenu, "defaultProps", {
  subMenuParentWidth: 0,
  subMenuParentHeight: 0,
  closeMenu() {
    // no-op
  },
  onMenuOpened() {
    // no-op
  },
  onMenuClosed() {
    // no-op
  },
  options: {},
  menuStyle: {},
  'data-testid': undefined
});
export default ContextMenu;
//# sourceMappingURL=ContextMenu.js.map